/****************************************************
 * Module Name:  dnkProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class DnkProxy {

    static UploadDnkExcel = (type, file, callback) => {
        restAPICall(
            Constants.WORKER_URL + `/upload/dnk/${type}`,
            "post",
            Constants.userToken,
            undefined,
            file,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}